import { fetchDirectusData } from '../../../api/directus';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

const useDirectusData = (
  collection: string,
  filters?: Record<string, string>,
  includeDetailedViews: boolean = false,
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: ['directusData', collection, filters],
    queryFn: () => fetchDirectusData(collection, filters, includeDetailedViews),
    ...options,
  });
};

export default useDirectusData;
